var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { class: _vm.classObj, staticStyle: { "box-sizing": "border-box" } },
      [
        _c("navbar", { attrs: { type: _vm.type } }),
        _vm._v("\n      " + _vm._s(_vm.sideShow) + "\n      "),
        _vm._v(" "),
        _c("sidebar", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.sideShow,
              expression: "!sideShow",
            },
          ],
          staticClass: "sidebar-container",
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            class: [
              "main-container",
              { hasTagsView: _vm.needTagsView },
              _vm.helpShow ? "left" : "",
            ],
          },
          [
            _c("headerToolbar", {
              ref: "header",
              attrs: { helpIsShow: _vm.helpShow, searchShow: _vm.searchShow },
              on: {
                handleSearchConfirm: _vm.handleConfirm,
                openOrCloseHelp: _vm.openHelp,
              },
            }),
            _vm._v(" "),
            _c("tags-view", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.needTagsView,
                  expression: "needTagsView",
                },
              ],
              staticClass: "tags-view-container",
            }),
            _vm._v(" "),
            _c("app-main"),
          ],
          1
        ),
        _vm._v(" "),
        _c("help", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.helpShow,
              expression: "helpShow",
            },
          ],
          attrs: { helpShow: _vm.helpShow },
          on: { closeHelp: _vm.closeHelp },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }